import React from 'react';
import './accordion.css';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: theme.typography.fontWeightRegular,
  },
}));

function AccordionComponent() {
  const classes = useStyles();

  return (
    <div className="accordion-container">
      <div className="accordion-sub-container">
        <div className={classes.root}>
          <h2 style={{ fontWeight: 'normal', color: '#333' }}>
            People also ask
          </h2>

          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel-ai-content"
              id="panel-ai-header"
            >
              <Typography className={classes.heading}>
                Can I pick your brain?
              </Typography>
            </AccordionSummary>

            <AccordionDetails>
              <Typography>
                Yes! I created an AI experience where anyone can pick my brain
                and explore my expertise through their own questions.{' '}
                <a
                  href="https://aicoach.giojuliao.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Try it here →
                </a>
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel-agentsy-content"
              id="panel-agentsy-header"
            >
              <Typography className={classes.heading}>
                What is Agentsy.pro?
              </Typography>
            </AccordionSummary>

            <AccordionDetails>
              <Typography>
                Agentsy.pro is the platform I founded to help consultants and
                experts unlock and drive business growth by
                letting prospects experience their expertise.{' '}
                <a
                  href="https://www.agentsy.pro"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Learn more →
                </a>
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel-achievements-content"
              id="panel-achievements-header"
            >
              <Typography className={classes.heading}>
                What are your major professional achievements?
              </Typography>
            </AccordionSummary>

            <AccordionDetails>
              <Typography>
                Led the product development of a fintech product where I cut
                almost completely the advertisement spend and still unlocked a
                +300% revenue and user growth.
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel-motivation-content"
              id="panel-motivation-header"
            >
              <Typography className={classes.heading}>
                What motivates you?
              </Typography>
            </AccordionSummary>

            <AccordionDetails>
              <Typography>
                Overcoming challenges, leading software development teams,
                learning new things, coming up with creative ideas to unlock
                growth, and making things happen!
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel-tools-content"
              id="panel-tools-header"
            >
              <Typography className={classes.heading}>
                What are your favourite tech tools?
              </Typography>
            </AccordionSummary>

            <AccordionDetails>
              <Typography>
                Personally, I love using Github kanban boards for managing my
                personal weekly sprints. Professionally, I prefer working with
                Jira for agile product management, HubSpot for CRM, Visual
                Studio Code for coding, Heroku and AWS for deployment, and
                Appsflyer for attribution.
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel-hobbies-content"
              id="panel-hobbies-header"
            >
              <Typography className={classes.heading}>
                What are your hobbies?
              </Typography>
            </AccordionSummary>

            <AccordionDetails>
              <Typography>
                I enjoy reading historical novels, playing soccer, and doing
                CrossFit. My favourite authors so far are Ken Follett, Julia
                Navarro, and Haruki Murakami. My biggest passion is tech,
                creating products, and software development.
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel-environment-content"
              id="panel-environment-header"
            >
              <Typography className={classes.heading}>
                What do you value the most in a working environment?
              </Typography>
            </AccordionSummary>

            <AccordionDetails>
              <Typography>
                What I value most is working with a team that has a growth
                mentality, where learning and solving challenges are valued
                above blaming others or focusing on failures.
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel-work-content"
              id="panel-work-header"
            >
              <Typography className={classes.heading}>
                Are you open for work?
              </Typography>
            </AccordionSummary>

            <AccordionDetails>
              <Typography>
                As an AI consultant, I help companies apply advanced AI
                assistants to real business problems to drive measurable growth
                and conversion.
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel-contact-content"
              id="panel-contact-header"
            >
              <Typography className={classes.heading}>
                Fastest way to reach you?
              </Typography>
            </AccordionSummary>

            <AccordionDetails>
              <Typography>
                LinkedIn DM or email. Contact me at me@giojuliao.com.
              </Typography>
            </AccordionDetails>
          </Accordion>
        </div>
      </div>
    </div>
  );
}

export default AccordionComponent;